var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"smallContent miscContent"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.message)+"\n        ")])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }